var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticStyle:{"width":"100%"}},[(_vm.viewShow=='pc')?_c('p-login',{staticClass:"pc"}):_vm._e(),(_vm.viewShow=='mobile')?_c('m-login',{staticClass:"mobile"}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }